import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PromptingService } from 'src/app/shared/services';
import { SortingTypeModel, FilteringTypeModel } from 'src/app/models/portal';
import {
  trigger,
  transition,
  style,
  state,
  animate,
} from '@angular/animations';
import { listAnimation } from 'src/app/shared/animations/animations';

import { LocalPaginationConfig } from 'src/app/models/owner-dashboard';
import { ContactItem } from 'src/app/components/user-dashboard/contacts/models/contacts';
import { SharedContactService } from '../../../../components/user-dashboard/contacts/shared-contact.service';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.css'],
  animations: [
    trigger('shrinkOut', [
      state('in', style({})),
      transition('* => void', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition('void => true', [
        style({ transform: 'translateX(-150px)', opacity: 0 }),
        animate(400, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    trigger('shrinkOutOnlyIn', [
      state('in', style({})),
      transition('void => *', [
        style({ transform: 'translateX(250px)', opacity: 0 }),
        animate(300, style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
    ]),
    listAnimation,
  ],
})
export class ContactsListComponent implements OnInit {
  contactsList: ContactItem[] = [];
  @Input('contactsList') set setContactsList(value: ContactItem[]) {
    this.contactsList = value;
    this.paginationConfig;
  }
  @Input() loaded: boolean = false;

  filterObject: FilteringTypeModel;

  paginationConfig: LocalPaginationConfig = new LocalPaginationConfig({
    currentPage: 1,
    startIndex: 0,
    numberInPage: 8,
    endIndex: 8,
  });
  // Pagination

  // Sort And Filtering Features
  searchWord: string = '';
  sortObject: SortingTypeModel = {
    displayName: 'Newest',
    column: 'createdAt',
    order: 'dsc',
  };

  filterTypes: FilteringTypeModel[] = [
    { index: 0, displayName: 'All', filters: [] },
    {
      index: 1,
      displayName: 'Students',
      filters: [{ column: 'type', value: 'student' }],
    },
    {
      index: 2,
      displayName: 'Instructors',
      filters: [{ column: 'type', value: 'instructor' }],
    },
    {
      index: 3,
      displayName: 'Leads',
      filters: [{ column: 'type', value: 'lead' }],
    },
  ];

  sortTypes: SortingTypeModel[] = [
    { displayName: 'Newest', column: 'createdAt', order: 'dsc' },
    { displayName: 'Oldest', column: 'createdAt', order: 'asc' },
    { displayName: 'A-Z Title', column: 'name', order: 'asc' },
    { displayName: 'Z-A Title', column: 'name', order: 'dsc' },
  ];

  @Output() onEditContact = new EventEmitter<ContactItem>();

  constructor(
    public sharedContactService: SharedContactService,
    private router: Router,
    private prompting: PromptingService,
  ) {}

  async ngOnInit() {
    // Data loading is handled by the parent or the service subscription
  }

  loadContact() {
    this.sharedContactService.getContacts();
  }

  // Sort And Filtering Features
  sortTypeChange(sortObject: SortingTypeModel) {
    this.sortObject = sortObject;
  }

  filterTypeChange(filterObject: FilteringTypeModel) {
    //
    this.filterObject = filterObject;
    this.paginationConfig.resetInitialValue();
  }

  resetPagination() {}

  async deleteContact(contact: ContactItem) {
    this.prompting
      .confirm(
        {
          allowOutsideClick: false,
          icon: 'error',
          input: 'checkbox',
          inputPlaceholder: `I understand that I'll permanently lose this <strong class="text-danger">contact and all associated data</strong>`,
          title: 'Are you sure want to delete?',
          html: `Are you sure want to delete <strong>${contact.name}</strong>.`,
          confirmButtonText: 'Delete',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            await this.sharedContactService.deleteContact(
              contact.id,
              contact.type,
            );
            return true;
          },
          inputValidator: (result) => {
            return !result && 'You need to agree';
          },
          isDanger: true,
        },
        'lg',
      )
      .then((res) => {
        if (res.isConfirmed) {
          this.loadContact();
        }
      });
  }

  //   cloneProduct(product: ProductItem) {
  //     this.sharedProductService.cloneProductAlert(product);
  //   }

  viewContact(id: number) {
    // this.router.navigate(['dashboard', 'contacts', id, 'view']);
  }

  public openEditModal(contact: ContactItem) {
    this.onEditContact.emit(contact);
  }

  //   goToTutorials() {
  //     this.router.navigate(['/dashboard/tutorials']);
  //   }

  onSearchWordChange(value: any) {
    this.searchWord = value;
  }

  consoleHandler(data: any) {}
}
